import { render, staticRenderFns } from "./CotizarSeguro.vue?vue&type=template&id=dd0be908&scoped=true&"
import script from "./CotizarSeguro.vue?vue&type=script&lang=js&"
export * from "./CotizarSeguro.vue?vue&type=script&lang=js&"
import style0 from "./CotizarSeguro.vue?vue&type=style&index=0&id=dd0be908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0be908",
  null
  
)

export default component.exports